export default __webpack_public_path__ + "static/1385-953150fb4f846e82e7df59be520ac77f.gif";